import { FormBase } from 'core/components';

export default class TaskPreviewEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'isOrderDone',
                    label: 'DASHBOARD.EDIT_ORDER.IS_ORDER_LABEL',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isDoneDocument',
                    label: 'DASHBOARD.EDIT_ORDER.IS_DOCUMENT_LABEL',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isDonePayor',
                    label: 'DASHBOARD.EDIT_ORDER.IS_PAYOR_LABEL',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isDoneIntake',
                    label: 'DASHBOARD.EDIT_ORDER.IS_INTAKE_LABEL',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isDoneBiller',
                    label: 'DASHBOARD.EDIT_ORDER.IS_BILLER_LABEL',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isInventoryDone',
                    label: 'DASHBOARD.EDIT_ORDER.IS_INVENTORY_DONE',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isSecondCheckDone',
                    label: 'DASHBOARD.EDIT_ORDER.IS_SECOND_CHECK',
                    type: 'bool',
                    default: false
                },
                
                {
                    name: 'notes',
                    label: 'SCHEDULE.CALENDAR.EDIT.NOTES_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.NOTES_PLACEHOLDER'
                },
                {
                    name: 'orderingDetailNote',
                    label: 'DASHBOARD.EDIT_ORDER.ORDERING_DETAIL_NOTE_LABEL',
                    placeholder: 'DASHBOARD.EDIT_ORDER.ORDERING_DETAIL_NOTE_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'backorderNote',
                    label: 'DASHBOARD.EDIT_ORDER.BACKORDER_NOTE_LABEL',
                    placeholder: 'DASHBOARD.EDIT_ORDER.BACKORDER_NOTE_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'intakeNote',
                    placeholder: 'FACILITY.EDIT.INTAKE_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'payorNote',
                    placeholder: 'FACILITY.EDIT.PAYOR_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'documentNote',
                    placeholder: 'FACILITY.EDIT.DOCUMENT_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'billingNote',
                    placeholder: 'FACILITY.EDIT.BILLING_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'isReminderIntake',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isReminderBiller',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isReminderPayor',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isReminderDocument',
                    type: 'bool',
                    default: false
                },
                {
                    name: 'isDone',
                    type: 'bool',
                    value: false
                },
                {
                    name: 'deliveryNotes',
                    label: 'SCHEDULE.CALENDAR.EDIT.DELIVERY_NOTES_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.DELIVERY_NOTES_PLACEHOLDER'
                },
                {
                    name: 'noSupply',
                    label: 'SCHEDULE.CALENDAR.EDIT.NOSUPPLY_LABEL',
                    type: 'bool',
                    value: false
                },
            ],
        };
    }
}
